import './BlackCheckbox.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var BlackCheckbox = function BlackCheckbox(_ref) {
  var id = _ref.id,
    required = _ref.required,
    checked = _ref.checked,
    className = _ref.className,
    label = _ref.label,
    _onChange = _ref.onChange;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: className,
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox__wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    className: "checkbox__input",
    id: id,
    type: "checkbox",
    checked: checked,
    onChange: function onChange(e) {
      _onChange(e.currentTarget.checked);
    },
    required: required
  }), /*#__PURE__*/React.createElement("label", {
    id: "".concat(id, "-label"),
    className: "checkbox__checkbox-label",
    htmlFor: id
  }, label)));
};
export default BlackCheckbox;
var StyledWrapper = function StyledWrapper(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className || "", " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "ctw88sd";
var rtlStyles = "riqbh9f";
var ltrStyles = "l125y1nz";